<template>
  <v-row
    justify="center"
    v-if="
      visitsBot && visitsBot.merged_df_final && visitsBot.merged_df_final.length
    "
  >
    <v-col lg="6" cols="12" sm="6" v-if="dataSource.series[0].data.length">
      <MixedCarts :dataSource="dataSource" />
    </v-col>
    <v-col lg="6" cols="12" sm="6" v-if="dataSource1.series[0].data.length">
      <MixedCarts :dataSource="dataSource1" />
    </v-col>
    <v-col
      cols="12"
      md="6"
      sm="12"
      lg="6"
      v-if="
        visitsBot &&
        visitsBot.merged_df_final_sum &&
        visitsBot.merged_df_final_sum.length
      "
    >
      <v-card outlined>
        <!-- <v-row justify="center" align="center" dense no-gutters class="text-center my-2"> -->
        <v-row justify="center" align="center" dense class="text-center my-2">
          <v-col cols="12">
            <v-icon class="mb-1" size="23" color="#51b2fc">
              mdi-robot-happy
            </v-icon>
            <span class="font-weight-black black--text">
              {{
                $t("analytics.general.VisitorsBot.card_elements.total_visits")
              }}
              :
            </span>
            <span class="subtitle-2 font-weight-black pink--text">
              {{ visitsBot.merged_df_final_sum[0].nb_visit_bot }}
            </span>
          </v-col>
          <!-- <v-col cols="12" v-if="this.$store.state.admin.storeId === '33'">
            <v-icon class="mb-1" size="23" color="purple">mdi-eye</v-icon>
            <span class="font-weight-black black--text">
              {{ $t("analytics.general.VisitorsBot.card_elements.total_seen") }}
              :
            </span>
            <span class="subtitle-2 font-weight-black pink--text">
              {{ visitsBot.merged_df_final_sum[0].nb_products_seen }}
            </span>
          </v-col>
          <v-col cols="12" v-if="this.$store.state.admin.storeId === '33'">
            <v-icon class="mb-1" size="23" color="pink darken-3">
              mdi-cursor-default-click
            </v-icon>
            <span class="font-weight-black black--text">
              {{
                $t("analytics.general.VisitorsBot.card_elements.total_clicked")
              }}
              :
            </span>
            <span class="subtitle-2 font-weight-black pink--text">
              {{ visitsBot.merged_df_final_sum[0].nb_products_clicked }}
            </span>
          </v-col> -->
          <v-col cols="12">
            <v-icon class="mb-1" size="23" color="#03dca0">
              mdi-cart-variant
            </v-icon>
            <span class="font-weight-black black--text">
              {{
                $t(
                  "analytics.general.VisitorsBot.card_elements.total_add_to_card"
                )
              }}
              :
            </span>
            <span class="subtitle-2 font-weight-black pink--text">
              {{
                visitsBot.merged_df_final_sum[0].nb_add_to_cart_with_assistant
              }}
            </span>
          </v-col>
          <v-col cols="12">
            <v-icon class="mb-1" size="23" color="#e8ae2f">mdi-wallet</v-icon>
            <span class="font-weight-black black--text">
              {{
                $t("analytics.general.VisitorsBot.card_elements.total_purchase")
              }}
              :
            </span>
            <span class="subtitle-2 font-weight-black pink--text">
              {{ visitsBot.merged_df_final_sum[0].nb_purchased_with_assistant }}
            </span>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
      sm="12"
      lg="6"
      v-if="
        visitsBot &&
        visitsBot.merged_df_final_sum &&
        visitsBot.merged_df_final_sum.length
      "
    >
      <v-card outlined min-height="99" class="text-center" height="100%">
        <v-row justify="center" align="center" class="mt-4">
          <v-col cols="12">
            <v-icon class="mb-1" size="23" color="#03dca0">
              mdi-cart-variant
            </v-icon>
            <span class="font-weight-black black--text">
              {{
                $t(
                  "analytics.general.VisitorsBot.card_elements.total_add_to_card_percentage"
                )
              }}
              :
            </span>
            <v-tooltip top color="black">
              <template v-slot:activator="{ on }">
                <span
                  class="subtitle-2 font-weight-black primary--text"
                  v-on="on"
                >
                  {{
                    (
                      visitsBot.merged_df_final_sum[0].percentage_add_to_cart *
                      100
                    ).toFixed(2)
                  }}%
                </span>
              </template>
              <span>
                {{
                  (
                    visitsBot.merged_df_final_sum[0].percentage_add_to_cart *
                    100
                  ).toFixed(9)
                }}%
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-icon class="mb-1" size="23" color="#e8ae2f">mdi-wallet</v-icon>
            <span class="font-weight-black black--text">
              {{
                $t(
                  "analytics.general.VisitorsBot.card_elements.total_purchase_percentage"
                )
              }}
              :
            </span>
            <v-tooltip top color="black">
              <template v-slot:activator="{ on }">
                <span
                  class="subtitle-2 font-weight-black primary--text"
                  v-on="on"
                >
                  {{
                    (
                      visitsBot.merged_df_final_sum[0].percentage_checkout * 100
                    ).toFixed(2)
                  }}%
                </span>
              </template>
              <span
                >{{
                  (
                    visitsBot.merged_df_final_sum[0].percentage_checkout * 100
                  ).toFixed(9)
                }}%</span
              >
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="6"
      sm="12"
      lg="6"
      v-if="
        visitsBot &&
        visitsBot.merged_df_final_sum &&
        visitsBot.merged_df_final_sum.length
      "
    >
      <v-card outlined min-height="99" class="text-center" height="100%">
        <v-row justify="center" align="center" class="mt-15">
          <v-col cols="12" class="mt-15">
            <h2>{{ $t("analytics.general.incremental.generated_revenue") }}</h2>
          </v-col>
          <v-col cols="12">
            <v-text-field
              class="ml-6 mr-6"
              v-model="price"
              outlined
              clearable
              label="Default 100€"
              type="text"
              :rules="[rules.only_digits]"
            >
              <template v-slot:prepend>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                  </template>

                  {{ $t("analytics.general.incremental.explanation") }}
                </v-tooltip>
              </template>

              <template v-slot:append>
                <v-fade-transition leave>
                  <v-progress-circular
                    v-if="loading_price"
                    size="24"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </v-fade-transition>
              </template>
            </v-text-field>
            <v-btn large color="primary" @click="onChangePrice">
              <v-icon left> mdi-target </v-icon
              >{{ $t("analytics.general.incremental.update") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <v-col lg="6" cols="12" sm="6" v-if="dataSource1.series[0].data.length">
      <LineChart
        :headers="headersIncremental"
        :dataset="dataSource2"
        :defaultDataset="defaultdf"
        ref="lineChart"
      />
    </v-col>
  </v-row>
</template>

<script>
import MixedCarts from "../charts/ApexCartsMixed.vue";
import LineChart from "../charts/LineChart.vue";
export default {
  name: "generalBotVisitors",
  components: {
    MixedCarts,
    LineChart,
  },
  data() {
    return {
      price: "",
      loading_price: false,
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      loading: false,
      dataSource: {
        height: 350,
        series: [
          {
            name: "visitors",
            type: "column",
            data: [],
          },
          {
            name: "add_to_card",
            type: "line",
            data: [],
          },
          {
            name: "purchase",
            type: "line",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "line",
          },
          stroke: {
            show: true,
            curve: "smooth",
            lineCap: "butt",
            colors: undefined,
            width: 2,
            dashArray: 0,
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0, 1, 2],
          },
          labels: [],
          legend: {
            show: true,
            showForSingleSeries: true,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: "bottom",
            horizontalAlign: "center",
            floating: false,
            fontSize: "14px",
          },
          xaxis: {
            type: "date",
          },
          yaxis: [
            {
              seriesName: "visitors",
              axisTicks: {
                show: true,
                color: undefined,
                offsetX: 10,
                offsetY: 0,
              },
              axisBorder: {
                show: true,
                color: "#008FFB",
                offsetX: -7,
                offsetY: 0,
              },
              labels: {
                style: {
                  colors: "#008FFB",
                },
              },
              title: {
                text: "Visitors Number",
                style: {
                  color: "#008FFB",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
            {
              seriesName: "add_to_card",
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#04dca0",
                offsetX: -7,
                offsetY: 0,
              },
              labels: {
                style: {
                  colors: "#04dca0",
                },
              },
              title: {
                text: "Add to card products",
                style: {
                  color: "#04dca0",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
            {
              seriesName: "purchase",
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#feb830",

                offsetX: -7,
                offsetY: 0,
              },
              labels: {
                style: {
                  colors: "#feb830",
                },
              },
              title: {
                text: "Purchase  products",
                style: {
                  color: "#feb830",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
          ],
        },
      },
      dataSource1: {
        height: 350,
        type: "bar",
        series: [
          {
            name: "",
            type: "column",
            data: [],
          },
          {
            name: "",
            type: "column",
            data: [],
          },
        ],
        chartOptions: {
          colors: ["#03dca0", "#e8ae2f"],
          chart: {
            height: 350,
            type: "column",
          },
          stroke: {
            show: true,
            curve: "smooth",
            lineCap: "butt",
            colors: undefined,
            width: 2,
            dashArray: 0,
          },
          dataLabels: {
            enabled: true,
            enabledOnSeries: [0, 1],
            formatter: function (val) {
              return val.toFixed(2) + "%";
            },
          },
          labels: [],
          legend: {
            show: true,
            showForSingleSeries: true,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: "bottom",
            horizontalAlign: "center",
            floating: false,
            fontSize: "14px",
          },
          xaxis: {
            type: "date",
          },
          yaxis: [
            {
              seriesName: "% Purchase / Assistant users",
              opposite: false,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#03dca0",
              },
              labels: {
                style: {
                  colors: "#03dca0",
                },
                formatter: function (val) {
                  return val ? val.toFixed(1) : val + "%";
                },
              },
              title: {
                text: "% Products per website visitors",
                style: {
                  color: "#03dca0",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
            {
              seriesName: "% Purchase / Assistant users",
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#e8ae2f",
              },
              labels: {
                style: {
                  colors: "#e8ae2f",
                },
                formatter: function (val) {
                  return val ? val.toFixed(1) : val + "%";
                },
              },
              title: {
                text: "% Products per website visitors",
                style: {
                  color: "#e8ae2f",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
          ],
        },
      },
      dataSource2: [
        {
          label: "Incremental revenue",
          data: [],
          //  price_data: [810, 1440, 2160, 3150],
          fill: true,
          borderColor: "#188CED",
          backgroundColor: "#dfebf5",
          borderWidth: 3,
        },
      ],
      rules: {
        only_digits: (v) =>
          /^[\d ]+$/.test(v) || "This field only accept numbers",
      },
      save: [],
      defaultdf: [
        {
          label: "Incremental revenue",
          data: [],
          fill: true,
          borderColor: "#188CED",
          backgroundColor: "#dfebf5",
          borderWidth: 3,
        },
      ],
      headersIncremental: [],
    };
  },
  computed: {
    visitsBot() {
      const data = this.$store.state.analytics.botVisitors;
      return data;
    },
  },
  async created() {
    this.loading = true;
    if (this.visitsBot && this.visitsBot.merged_df_final)
      await this.init_vals();

    this.save = [...this.dataSource2[0].data];
    this.loading = false;
  },
  methods: {
    onChangePrice() {
      if (this.price === undefined || !/^[\d ]+$/.test(this.price)) {
        return;
      }
      const input = this.price;
      this.loading_price = true;
      for (let i = 0; i < this.dataSource2[0].data.length; ++i) {
        this.dataSource2[0].data[i] = this.save[i] * input * 0.15;
      }
      this.$refs.lineChart.update();
      setTimeout(() => {
        this.loading_price = false;
      }, 1000);
    },
    init_vals() {
      console.log(this.visitsBot.merged_df_final);
      for (let i = 0; i < this.visitsBot.merged_df_final.length; i++) {
        //left chart setter
        const element = this.visitsBot.merged_df_final[i];
        this.dataSource.chartOptions.labels.push(
          `${this.monthNames[element.month - 1]} - ${element.year}`
        );
        this.dataSource.series[0].data.push(element.nb_visit_bot);
        this.dataSource.series[0].name = this.$t(
          "analytics.general.VisitorsBot.graph_elements.Number_visitors"
        );
        this.dataSource.series[1].data.push(
          element.nb_add_to_cart_with_assistant || 0
        );
        this.dataSource.series[1].name = this.$t(
          "analytics.general.VisitorsBot.graph_elements.products_add_to_cart"
        );
        this.dataSource.series[2].data.push(
          element.nb_purchased_with_assistant || 0
        );
        this.dataSource.series[2].name = this.$t(
          "analytics.general.VisitorsBot.graph_elements.products_purchase"
        );
        //right chart setter
        this.dataSource1.chartOptions.labels.push(
          `${this.monthNames[element.month - 1]} - ${element.year}`
        );
        const val1 =
          (element.nb_purchased_with_assistant / element.nb_visit_bot) * 100;
        const val2 =
          (element.nb_add_to_cart_with_assistant / element.nb_visit_bot) * 100;
        this.dataSource1.series[1].data.push(val1.toFixed(2));
        this.dataSource1.series[1].name = this.$t(
          "analytics.general.VisitorsBot.graph_elements.purchase_website_visitors"
        );
        this.dataSource1.series[0].data.push(val2.toFixed(2));
        this.dataSource1.series[0].name = this.$t(
          "analytics.general.VisitorsBot.graph_elements.add_to_cart_website_visitors"
        );
        // Incremental revenu chart
        this.headersIncremental.push(
          `${this.monthNames[element.month - 1]} - ${element.year}`
        );
        this.defaultdf[0].data.push(
          element.nb_purchased_with_assistant * 100 * 0.2
        );
        this.dataSource2[0].data.push(element.nb_purchased_with_assistant);
        this.defaultdf[0].label = this.$t(
          "analytics.general.incremental.generated_revenue"
        );
        this.dataSource2[0].label = this.$t(
          "analytics.general.incremental.generated_revenue"
        );
      }
    },
  },
};
</script>
